export default __webpack_public_path__ + "static/media/yeti.c4dcbf5e.gif";